import type { AddPayOutAccountInput } from '../../../../../core/api/shared/@types/generated/backend/graphql-schema-types'

type OnPayOutInstrumentAddedFn = (id?: string) => void

export const usePayoutSingleton = () => {
  const isUseManualAccountsOnly = inject('isUseManualAccountsOnly', ref(false))

  const licensedTerritory = useLicensedTerritory({ raw: true })

  const onPayOutInstrumentAddedCb = useState<OnPayOutInstrumentAddedFn>(() => () => {})

  const { mutate: invokeAddPayoutMethod, onDone: onAddPayoutInstrumentDone } =
    useAddPayOutInstrumentMutation()

  const { mutate: confirmMfa, onDone: onSyncAeropayDone } = useConfirmAeropayMfaMutation()

  const addPayOutInstrument = (
    type: AddPayOutAccountInput['type'],
    providerSpecificData: AddPayOutAccountInput['providerSpecificData'],
  ) =>
    invokeAddPayoutMethod(
      {
        input: {
          idempotencyKey: crypto.randomUUID(),
          licensedTerritory,
          providerSpecificData,
          type,
        },
      },
      {
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: PayOutAccountsDocument,
            variables: {
              licensedTerritory,
              useManualAccountsOnly: isUseManualAccountsOnly.value,
            },
          },
        ],
      },
    )

  onAddPayoutInstrumentDone((response) => {
    const id = response?.data?.addPayOutAccount.id

    if (!id) return
    publish(id)
  })

  onSyncAeropayDone((response) => {
    const id = response?.data?.confirmMfa.preferredPayOutAccountId

    if (!id) return
    publish(id)
  })

  const publish = (accountId?: string) => {
    onPayOutInstrumentAddedCb.value(accountId)
  }

  const syncAeropayPayoutMethods = ({
    mfaCode,
    phoneNumber,
    userId,
  }: {
    mfaCode: string
    phoneNumber: string
    userId: string
  }) =>
    confirmMfa(
      {
        input: {
          licensedTerritory,
          mfaCode,
          phoneNumber,
          userId,
        },
      },
      {
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: PayOutAccountsDocument,
            variables: { licensedTerritory, useManualAccountsOnly: false },
          },
        ],
      },
    )

  return {
    addPayOutInstrument,
    onPayOutInstrumentAdded: (cb: OnPayOutInstrumentAddedFn) =>
      (onPayOutInstrumentAddedCb.value = cb),
    publish,
    syncAeropayPayoutMethods,
  }
}
